
export default {
    name: 'AccountInfoAml',

    props: {
        accountIntervenersRisk: {
            type: Array,
            required: false
        },
        isIntervener: {
            type: Boolean,
            required: false
        }
    },
    computed: {
        normalizedRiskData() {
            // Si ya vienen como array con estructura `.aml`, se devuelve tal cual
            if (!this.isIntervener) {
                return this.accountIntervenersRisk;
            }

            // Si viene como un único objeto AML plano (caso Intervener), se adapta
            const aml = this.accountIntervenersRisk[0]

            return [{
                aml: {
                    risk: aml.risk,
                    scoring: aml.scoring,
                    active_flags: aml.active_flags,
                    customer_link: aml.customer_link
                }

            }];
        }
    }

};
